import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import Button from '../Button';
import DropSection from '../DropSection';
import ImagePreview from '../ImagePreview';

import styles from './styles.scss';

class ImageUpload extends React.Component {
  static get propTypes() {
    return {
      files: PropTypes.array,
      onDrop: PropTypes.func,
      onClear: PropTypes.func,
      base64: PropTypes.array,
      showIcon: PropTypes.bool,
      isTestImages: PropTypes.bool,
      maxSize: PropTypes.number,
    };
  }

  render() {
    const { onDrop, isTestImages, files, onClear, base64, showIcon, maxSize } = this.props;
    const smDropZone = isTestImages ? 12 : 6;
    const smPreviewrContainer = isTestImages ? 11 : 6;

    return (
      <Container className="px-0">
        <Row className="text-left">
          <Col xs={12} sm={smDropZone} className="mb-3">
            <DropSection accept="image/*" onDrop={onDrop} multiple={isTestImages || false} maxSize={maxSize} />
          </Col>
          <Col xs={12} sm={smPreviewrContainer} className="text-center mb-3">
            <Row className={`d-table w-100 ${styles.previewContainer}`}>
              {files.map((file, index) => (
                <Col key={index} className={`d-table-cell ${styles.imageWrap}`}>
                  <Choose>
                    <When condition={file}>
                      <ImagePreview src={file.preview} />
                    </When>
                    <Otherwise>
                      <Choose>
                        <When condition={base64[index]}>
                          <ImagePreview src={`data:image/png;base64, ${base64[index]}`} />
                        </When>
                        <Otherwise>
                          <ImagePreview />
                        </Otherwise>
                      </Choose>
                    </Otherwise>
                  </Choose>
                  <Col key={index}>
                    <Button
                      disabled={!file && !base64[index]}
                      className={`mt-3 ${styles.clearButton}`}
                      kind="danger"
                      onClick={() => onClear(index)}
                    >
                      {showIcon ? <i className="fa fa-eraser mr-1" /> : ''} Clear image
                    </Button>
                  </Col>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ImageUpload;



// WEBPACK FOOTER //
// src/components/shared/ImageUpload/index.jsx